import type { LazyGuestPage } from './guest-types';

/**
 * The real guest product registry. Empty in P0d — no product page is wired to the guest shell
 * yet. `GuestShell` defaults to this; a Storybook/test fixture registry is passed explicitly where
 * a product page is needed, never added here.
 */
export const GUEST_PRODUCT_PAGES: Readonly<Record<string, LazyGuestPage>> = {};
